import camelize from "global/utils/camelize";
import { funAcortarText } from "../../../../../global/utils/text";
import TildeOk from "../../../../assets/images/generico/TildeOk";
import {
  ContainerCardGuardar,
  ContainerText,
  TopCardGuardar,
} from "./localstyle";

const CardAguardar = ({
  nombreTurno,
  sedeTurno,
  pisoTurno,
  consultorioTurno,
  horaTurno,
  btnDisable,
  handleClick,
  index,
  flgSoloConsulta,
  medico,
  filaVirtual,
}) => {
  const funAMOrPM = (hora) => {
    hora = hora.slice(0, 2);
    hora = Number(hora);
    if (hora > 12) return "PM";
    else return "AM";
  };

  return (
    <ContainerCardGuardar filaVirtual={filaVirtual}>
      <TopCardGuardar filaVirtual={filaVirtual}>
        <div className="circle">
          <TildeOk color={"#fff"} />
        </div>
        {funAcortarText(28, nombreTurno)}
      </TopCardGuardar>
      <ContainerText>
        <span className="bold">
          Horario:{" "}
          <span>
            {horaTurno} {funAMOrPM(horaTurno)}
          </span>
        </span>
        <span className="bold">
          Sede: <span> {funAcortarText(20, sedeTurno)} </span>
        </span>
        <span className="bold">
          Piso: <span> {funAcortarText(20, pisoTurno)} </span>
        </span>
        <span className="bold">
          Consultorio: <span>{funAcortarText(40, consultorioTurno)}</span>
        </span>
        {flgSoloConsulta ? (
          <p className="rb18b">
            Especialista:{" "}
            <span className="rb18l">
              {funAcortarText(35, camelize(medico))}
            </span>
          </p>
        ) : (
          ""
        )}
      </ContainerText>
      {btnDisable ? (
        ""
      ) : (
        <button
          className="btn-aguardar"
          onClick={() => {
            handleClick(index);
          }}
        >
          Aguarde a ser llamado
        </button>
      )}
    </ContainerCardGuardar>
  );
};

export default CardAguardar;
